module.exports = __webpack_public_path__ + "img/undraw_for_review.1b8acab5.svg";